export const LIST_COURSES = '/:organizationType/rating/';
export const LIST = '/:organizationType/rating/klientskij/';
export const LIST_BY_CATEGORY =
  '/:organizationType/rating/klientskij/:productCategory(dlya-predprinimatelej|dlya-chastnyh-lic)/';
export const LIST_BY_TAG = '/:organizationType/rating/klientskij/:reviewTagAlias/';
export const LIST_MFO = '/:organizationType/rating-mfo/';
